let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajKPE")).then(() => parcelRequire('3Eb0P'));